/**
 * Created by Yoyo Fang on 09/23/2018.
 * Description:
 * Http Error Interceptor for global http error handling
 * ------ maintenance history ------
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { AppState } from '../redux';
import { SessionTimeout, LoginFailed } from '../redux/actions/auth.actions';
import { AuthStatusTypes } from '../redux/reducers/auth.reducer';
import { UserMessages } from '../constants/userMessages.constants';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private _store: Store<AppState>,
        private _router: Router,
    ) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next
            .handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    const isOnLoginPage = this._router.url.startsWith('/login') || this._router.url.startsWith('/admin-login');
                    let currentAuthStatus = '';
                    this._store.pipe(select('auth')).subscribe(state => currentAuthStatus = state?.status || '').unsubscribe();
                    // Do not dispatch SESSION_TIMEOUT when user has already logged out or a timeout is already
                    // in progress — prevents stale 401s from spawning multiple logout() calls that race with
                    // a subsequent successful login.
                    const shouldDispatch = !isOnLoginPage
                        && currentAuthStatus !== AuthStatusTypes.LOGOUT
                        && currentAuthStatus !== AuthStatusTypes.SESSION_TIMEOUT;
                    switch (error.status) {
                        case 400:
                            if (shouldDispatch && error.error.includes('ERR_NO_TOKEN')) {
                                this._store.dispatch(new SessionTimeout(UserMessages.onSessionTimeout, this._router.url));
                            }
                            break;
                        case 401:
                            if (shouldDispatch && !request.url.includes('/token/')) {
                                this._store.dispatch(new SessionTimeout(UserMessages.onSessionTimeout, this._router.url));
                            }
                            break;
                        case 408:
                        case 503:
                            this._store.dispatch(new LoginFailed(UserMessages.onAPIDown));
                            break;
                        default:
                        // TODO: define default http error fallback
                    }
                    return throwError(error);
                })
            );
    }
}
